import React from "react";
import {Layout, Breadcrumb, Button, message, Space, Row, Col} from 'antd';
import {Link} from "react-router-dom";
import eeIcon from "../assets/icons/et.png";
import enIcon from "../assets/icons/en.png";
import fiIcon from "../assets/icons/fi.png";
import axios from "axios";
import {getCookie} from "../helpers";

const {Content} = Layout;

const LANGUAGES = [
    {name: "Estonian", lang: "et", icon: eeIcon},
    {name: "English", lang: "en", icon: enIcon},
    {name: "Finnish", lang: "fi", icon: fiIcon},
];

const Translations = () => {
    const syncTranslations = () => {
        const apiDomains = ['https://api.fitlap.ee', 'https://api.fitlap.com', 'https://api.fitlap.in', 'http://127.0.0.1:8000', 'https://api2.fitlap.fi'];
        const token = getCookie('fl_admin_access_token');

        apiDomains.forEach(domain => {
            axios({
                method: "put",
                url: "/admin/translations/sync",
                baseURL: domain,
                data: [],
                headers: {
                    'X-Auth-Token': `4sC6KWJisLkOkFQCW5xU`,
                    'Authorization': `Bearer ${token}`
                },
            }).then(() => {
                message.success('Translations synced: ' + domain);
            });
        });
    };

    return (
        <Content style={{margin: '0 16px'}}>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item>Fitlap</Breadcrumb.Item>
                <Breadcrumb.Item>Translations</Breadcrumb.Item>
            </Breadcrumb>

            <div className="site-layout-card">
                <Space style={{marginBottom: 20}}>
                    <h1 style={{margin: 0}}>Languages</h1>
                    <Button onClick={syncTranslations} type="primary">Sync</Button>
                </Space>

                <Row gutter={[16, 16]}>
                    {LANGUAGES.map((item) => (
                        <Col xs={24} sm={12} md={8} key={item.lang}>
                            <Link to={item.lang} className="language-card">
                                <img className="language-card__flag" src={item.icon} alt={item.name}/>
                                <div className="language-card__content">
                                    <div className="language-card__name">{item.name}</div>
                                    <div className="language-card__code">{item.lang}</div>
                                </div>
                            </Link>
                        </Col>
                    ))}
                </Row>
            </div>
        </Content>
    );
};

export default Translations;
